// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_L1c","cls2":"RelatedPapersSidebar-cls2_Rl- RelatedPapersSidebar-cls1_L1c"};